<template>
    <div>
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="whiteBG p-3 education-Section mb-4">
            <section class="blockElement mainBanner ">
                <div class="inner-banner-custom row align-items-center">
                    <div class="col-12 text-center">
                        <h2 class="mb-3">{{$t('edu_learnTrade')}}</h2>
                        <div class="shwContentmain customTab-show" v-on:click.prevent = "tabFunc('zero')" :class="(showData == 'zero')?'active' : ''">
                            <p>{{$t('edu_offerEdu')}}</p>
                        </div>
                        <div class="shwContentmain customTab-show" v-on:click.prevent = "tabFunc('one')" :class="(showData == 'one')?'active' : ''">
                            <p>{{$t('edu_Enhance')}}</p>
                            <p>{{$t('edu_tradeconfidence')}}</p>
                        </div>
                        <!-- <div class="buttonBanner d-flex align-items-center">
                            <a href="#" target="_blank" class="cr-btn hvr-sweep-to-right whiteBG mt-4">Create Accout</a>
                        </div> -->
                    </div>
                </div>
            </section>

         <!--Section-->
            <section class="blockElement doticonHover tp position-relative">
                <div class="row">
                    <div class="col-12"> 
                        
                         <ul class="nav nav-tabs mr-5 tabBachkrod leftCustom-width in-trading">
                            <li class="nav-item"><a class="nav-link" href="#" v-on:click.prevent = "tabFunc('zero')" :class="(showData == 'zero')?'active' : ''">{{$t('edu_basic')}}</a></li>
                            <li class="nav-item"><a class="nav-link" href="#" v-on:click.prevent = "tabFunc('one')" :class="(showData == 'one')?'active' : ''">{{$t('edu_advance')}}</a></li>
                        </ul>
                        <div class="d-flex mt-4">
                            <ul class="nav nav-tabs mr-3 tabBachkrod viewModal-currency border-0 p-3">
                                <li class="nav-item"><a class="nav-link" href="#">{{$t('edu_general')}}</a></li>
                                <li class="nav-item"><a class="nav-link" href="#">{{$t('edu_forex')}}</a></li>
                                <li class="nav-item"><a class="nav-link" href="#">{{$t('edu_commodities')}}</a></li>
                                <li class="nav-item"><a class="nav-link" href="#">{{$t('edu_indices')}}</a></li>
                                <li class="nav-item"><a class="nav-link" href="#">{{$t('edu_stocks')}}</a></li>
                            </ul>
                            <div class="mb-3 tab-responsive customTab-show active customTabEducation">
                                <div class="row">
                                    <div class="col-12 col-md-4" v-for="list in post_data">
                                        <div class="fancy-card">
                                            <a href="#" class="box">
                                               {{list.title}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="noRecordFound" v-if="post_data.length == 0 && !pageLoader"> 
                                    <img src="../../../../../static/fxView/images/search.svg" alt="no record found">
                                    <p>{{$t('edu_thereIsNoRecord')}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="mb-3 tab-responsive customTab-show" v-on:click.prevent = "tabFunc('one')" :class="(showData == 'one')?'active' : ''">
                             <div class="row">
                                <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Technical Analysis
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Fundamental Analysis
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Chart Patterns
                                        </a>
                                    </div>
                                </div>
                                 <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Support & Resistance
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Trend Lines
                                        </a>
                                    </div>
                                </div>
                                 <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Fibonacci Trading Strategy
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Relative Strength Index
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Moving Averages
                                        </a>
                                    </div>
                                </div>
                                 <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Pivot Points
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Expert Advisors
                                        </a>
                                    </div>
                                </div>
                                 <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Indicator Package
                                        </a>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="fancy-card">
                                        <a href="#" class="box">
                                           Trader's Toolbox
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        
                    </div>
                </div>
            </section>
        </div>
        <!-- <section class="blockElement">
                <h3 class="mb-3 mb-md-4 text-left">Learn More About Forex</h3>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="fancy-card">
                            <a href="#" class="box">
                               Forex Glossary
                            </a>
                        </div>
                    </div> 
                    <div class="col-12 col-md-6">
                        <div class="fancy-card">
                            <a href="#" class="box">
                               Video Tutorials
                            </a>
                        </div>
                    </div> 
                    <div class="col-12 col-md-6">
                        <div class="fancy-card">
                            <a href="#" class="box">
                               Market News
                            </a>
                        </div>
                    </div> 
                    <div class="col-12 col-md-6">
                        <div class="fancy-card">
                            <a href="#" class="box">
                               FAQs
                            </a>
                        </div>
                    </div>  
                </div>
        </section> -->
    </div>
</template>
<script>
    export default {
        name: 'Basic Education',
        data() {
            return {
                showData : 'zero',
                post_data:[],
                pageLoader : false,
                msg_type : '',
                response_msg : ''
            }
        },

        methods:{
            tabFunc(getData){
                this.showData = getData
            }
        },
        created(){
        	this._runGetPostData({'globalParams' : {} ,'localParams' : {'parameter' : this}})
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/research/pages/basic_education.vue